import {
  commonSlice,
  InitialCommonStateType,
  showTemplateGalleryModal,
  showTemplateGalleryModalDetailsScreen,
} from 'src/store/commonPart/slice';
import { store } from 'src/store/store';
import { SafeAnyType } from 'src/utils/safeAny';
import i18n from 'i18next';

export const dispatchOverlayShareShow = (data: NonNullable<InitialCommonStateType['overlayShareLink']>) => {
  store.dispatch<SafeAnyType>(commonSlice.actions.overlayShareLinkShow(data));
};

export const dispatchOverlayShareHide = () => {
  store.dispatch<SafeAnyType>(commonSlice.actions.overlayShareLinkHide());
};

export const dispatchShowTemplateGalleryModal = (
  calledFrom?: InitialCommonStateType['templateGalleryModalCalledFrom']
) => {
  i18n.loadNamespaces('modals.templateGallery', () => {
    store.dispatch<SafeAnyType>(showTemplateGalleryModal(calledFrom || null));
  });
};

export const dispatchShowTemplateGalleryModalDetailsScreen = (id: string) => {
  i18n.loadNamespaces('modals.templateGallery', () => {
    store.dispatch<SafeAnyType>(showTemplateGalleryModalDetailsScreen(id));
  });
};

export const dispatchShowPersonalOrBusinessForBusinessModal = () => {
  i18n.loadNamespaces('modals.personalOrBusinessForBusiness', () => {
    store.dispatch(commonSlice.actions.showPersonalOrBusinessForBusinessModal());
  });
};
